import { css } from 'lit';

export const rigSharedStyles = css`
  .operation-rig li {
    background: powderblue;
    margin: 5px;
    padding: 5px;
  }

  .active {
    background: pink;
    padding: 5px;
  }

  .pending {
    background: aqua;
    padding: 5px;
  }

  .app {
    display: flex;
    flex-direction: column;
    margin: 30px;
    padding: 30px;
    background-image: none;
    background-color: white;
    border: 1px solid gainsboro;
  }

  .token {
    padding: 5px 10px;
    margin: 2px 5px;
    background: aliceblue;
    outline: 1px dashed gray;
    white-space: nowrap;
    font-family: monospace;
    font-size: small;
    margin: 3px;
    border-radius: 15px;
    display: inline-block;
  }
  .token.realtime {
    background: yellow;
  }
  .token.delayed {
    background: beige;
  }
  .token.default {
    background: lavender;
  }
  li {
    padding: 10px;
  }
  input[type='text'] {
    min-width: 300px;
  }
`;
